const colorCache = new Map()

// Deterministic hash of a string into a hex color, cached (module-level, for the life of
// the page session) so the same input never re-runs the hash loop — extracted from
// shared/ui/AvatarInitial.js's own original implementation so every caller (avatar
// circles, calendar event color bars/dots, ...) that colors the same name gets the exact
// same hex value.
export const stringToColor = (string) => {
  if (colorCache.has(string)) return colorCache.get(string)

  let hash = 0
  let i

  /* eslint-disable no-bitwise */
  for (i = 0; i < string.length; i += 1) {
    hash = string.charCodeAt(i) + ((hash << 5) - hash)
  }

  let color = '#';

  for (i = 0; i < 3; i += 1) {
    const value = (hash >> (i * 8)) & 0xff;
    color += `00${value.toString(16)}`.slice(-2)
  }
  /* eslint-enable no-bitwise */

  colorCache.set(string, color)
  return color
}
